import { IconCodeOutline18 as Code } from "nucleo-ui-outline-18"

import { IconButton, Tooltip } from "@productlane/ui"

import { formatJsonDraft } from "../model/json-value-draft"

/**
 * Reindents on demand only. Formatting while the author types would move the caret
 * out from under them.
 */
export function ReformatJsonButton({
	text,
	onFormat,
}: {
	text: string
	onFormat: (formatted: string) => void
}) {
	const formatted = formatJsonDraft(text)

	return (
		<Tooltip label="Reformat" shouldWrapChildren>
			<IconButton
				Icon={Code}
				variant="ghost"
				size="sm"
				aria-label="Reformat"
				disabled={formatted === text}
				onClick={() => onFormat(formatted)}
			/>
		</Tooltip>
	)
}
